import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../service/api.service';
import {HelperService} from '../service/helper.service';
import {Base64Util} from '../utils/base64Util';
import {ModalController, NavController} from '@ionic/angular';
import {AccountService} from '../service/account.service';
import {TranslateConfigService} from '../service/translate-config.service';
import {DatePipe} from '@angular/common';
import {VerifyPhoneComponent} from '../verify-phone/verify-phone.component';
import {UpdatePasswordComponent} from "../update-password/update-password.component";

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.page.html',
  styleUrls: ['./user-edit.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserEditPage implements OnInit {
  selectSegment: number;

  oldpwd = '';
  newpwd = '';
  newpwd2 = '';
  userLogin = '';
  userNickname = '';
  userPhone = '';
  birthday = '';
  maxDate = '';
  address = '';
  email = '';
  agent = '';
  name = '';

  passwordOld: any;
  userInfoOld: any;
  base64Util: any;

  isVerifyPhone = false;
  isChangePass = false;

  constructor(
    private apiService: ApiService,
    public hpService: HelperService,
    protected route: ActivatedRoute,
    private navController: NavController,
    private accountService: AccountService,
    public modalCtr: ModalController,
    private translateConfigService: TranslateConfigService,
    private datepipe: DatePipe
  ) {
    this.base64Util = new Base64Util();
    this.selectSegment = 0;
    this.translateConfigService.setLanguage(this.translateConfigService.getDefaultLanguage());
  }

  ngOnInit() {
    this.maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().substring(0, 10);
    this.userInfoOld = JSON.parse(this.base64Util.decode(localStorage.getItem('userInfo')));
    this.passwordOld = this.base64Util.decode(localStorage.getItem('pa'));
    this.userLogin = localStorage.getItem('ur');

   // this.userNickname = localStorage.getItem('nickName');
   // this.userNickname = localStorage.getItem('nickName');
   // this.email = this.userInfoOld.email;
  //  this.userPhone = this.userInfoOld.phone;
 //   this.address = this.userInfoOld.address;
 //   this.birthday = this.userInfoOld.birthday;
 //   this.agent = this.userInfoOld.agent;
 //   this.name = this.userInfoOld.name;
 //   this.isVerifyPhone = localStorage.getItem('phoneVerify') != null && localStorage.getItem('phoneVerify') == 'true' ? true : false;
  //  this.isChangePass = this.userInfoOld.isPass2 === 0 ? false : true;
  }

  async closeModal() {
    await this.modalCtr.dismiss();
  }

  segmentChanged(event: any): void {
  }

  updatePassLogin() {
    const loaderCustom = this.hpService.loaderCommon();

    let msg = '';
    if (!this.oldpwd && this.oldpwd === '') {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-old-pass-blank');
    } else if (!this.newpwd && this.newpwd === '') {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-new-pass-blank');
    } else if (!this.newpwd2 && this.newpwd2 === '') {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-retype-new-pass-blank');
    } else if (this.newpwd !== this.newpwd2) {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-retype-pass-incorrect');
    } else if (this.oldpwd === this.newpwd) {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-pass-not-same');
    } else if (this.oldpwd.length < 6 || this.newpwd.length < 6 || this.newpwd2.length < 6) {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-password-length');
    } else if (this.oldpwd !== this.passwordOld) {
      msg = this.translateConfigService.getTranslateService().instant('MESSAGE.valid-old-pass-incorrect');
    }

    if (msg !== '') {
      loaderCustom.then(ldRes => ldRes.dismiss());
      this.hpService.handleError(msg);
      return;
    }
    const params = {
      currentPassword: this.oldpwd,
      newPassword: this.newpwd
    };

    this.apiService.changePassword(params, loaderCustom).subscribe(data => {
      loaderCustom.then(ldRes => ldRes.dismiss());

      this.passwordOld = this.newpwd;
      localStorage.setItem('pa', this.base64Util.encode(this.newpwd));
      /* this.hpService.handlerSuccess(this.translateConfigService.getTranslateService().instant('MESSAGE.change-pass-success')).then(res => {
        this.navController.back();
       });*/
      this.hpService.presentToast(this.translateConfigService.getTranslateService().instant('MESSAGE.change-pass-success'));
      this.closeModal();
    });
  }

  updateInfo() {
    const loaderCustom = this.hpService.loaderCommon();

    const params = {
      id: this.userInfoOld.id,
      login: this.userInfoOld.login,
      nickName: this.userNickname,
      email: this.email,
      phone: this.userPhone,
      address: this.address,
      birthday: (this.birthday != null && this.birthday !== '') ? this.datepipe.transform(this.birthday, 'yyyy-MM-dd') + 'T00:00:00' : null,
      password: this.userInfoOld.password,
      agent: this.agent,
      name: this.name
    };
    this.apiService.updateUserInfo(params, loaderCustom).subscribe(data => {
      if (data.status === this.hpService.ERROR_CODE_SUCCESS) {
        localStorage.setItem('userInfo', this.base64Util.encode(JSON.stringify(params)));
        this.hpService.handlerSuccess(this.translateConfigService.getTranslateService().instant('MESSAGE.change-info-success')).then(res => {
          this.navController.back();
        });
      } else {
        this.hpService.handleError(data.message);
      }
    });
  }

  checkName(name: string) {
    const regex = /^([a-zA-Z0-9])+$/;
    return regex.test(name);
  }

  formatHideInfo(data) {
    if (!data) {
      return '';
    }
    return (data && data.length > 3) ? `${data.slice(0, 4)}****${data.slice(data.length - 3, data.length)}` : `${data.slice(0, 1)}***`;
  }

  isLoginFacebook() {
    return this.accountService.isLoginFacebook;
  }

  async openVerifyPhoneModal() {
    const modal = await this.modalCtr.create({
      component: VerifyPhoneComponent,
      mode: 'ios',
      cssClass: 'modal-verify-phone',
      componentProps: {
        time: true
      }
    });

    modal.onDidDismiss()
      .then((ev) => {
        if (ev.data !== undefined) {
          this.userPhone = ev.data;
          this.updateInfo();
          this.isVerifyPhone = true;
        }
      });

    return await modal.present();
  }

  async openChangePassWithdrawModal() {
    const modal = await this.modalCtr.create({
      component: UpdatePasswordComponent,
      mode: 'md',
      componentProps: {
        isChange: true
      }
    });

    return await modal.present();
  }
}
